import Logger from '../services/logger.service'

export const decodeJwtToken = (token: string) => {
  try {
    const authToken = token.split('.')[1]
    const decoded = atob(authToken.replace(/-/g, '+').replace(/_/g, '/'))
    return JSON.parse(decoded)
  } catch (err) {
    Logger.errorObj('[Auth Util]: Error decoding JWT token', err)
    return null
  }
}

export const isTokenValid = (token: string) => {
  try {
    const decodedToken = decodeJwtToken(token)
    if (!decodedToken || typeof decodedToken.exp !== 'number') {
      Logger.info(`[Auth Util]: Token is invalid ${decodedToken}`)
      return false
    }

    const now = Math.floor(Date.now() / 1000)
    const minRemainingSeconds = 120 // token must have at least 120s remaining

    return decodedToken.exp > now + minRemainingSeconds
  } catch (err) {
    Logger.errorObj('[Auth Util]: Error validating token', err)
    return false
  }
}
